// @cloudnest/cascadia-engine — types barrel.
// Per `docs/guides/coding-conventions/02-typescript-javascript.md`,
// `verbatimModuleSyntax` requires `export type` for type-only re-exports.

export type {
  Action,
  ActionType,
  ChooseLandmarkCardAction,
  DraftDecoupledAction,
  DraftPairAction,
  EndTurnAction,
  InitAction,
  PlaceTileAction,
  PlaceWildlifeAction,
  ReturnWildlifeAction,
  SkipLandmarkAction,
  SpendNatureDecoupleAction,
  SpendNatureWipeAction,
  UnlockLandmarkAction,
  WipeMarketOptionalAction,
} from "./actions";
export type {
  CardSetLabel,
  WildlifeRule,
  WildlifeScoringCardDef,
} from "./card";
export type { ErrResult, OkResult, Result, ValidationResult } from "./common";
export { err, isErr, isOk, ok } from "./common";
export type { AxialCoord, EdgeIndex, NeighbourOffset } from "./coords";
export {
  coordEquals,
  coordKey,
  NEIGHBOUR_OFFSETS,
  parseCoordKey,
} from "./coords";
export type {
  AutoWipeMarketEvent,
  RefillMarketEvent,
  ScoreGameEvent,
  ServerEvent,
  ServerEventType,
} from "./events";
export type {
  ModuleFlags,
  PlayerCount,
  RngConfig,
  Ruleset,
} from "./game-config";
export type {
  GameState,
  ScoringCardSelection,
  TurnPhase,
  TurnState,
} from "./game-state";
export type { Habitat } from "./habitat";
export { HABITATS } from "./habitat";

export type {
  LandmarkCardDef,
  LandmarkEffect,
  LandmarkSetLabel,
} from "./landmark";

export type { Market, MarketSlot, MarketSlotIndex } from "./market";
export type {
  Board,
  BoardCell,
  PlayerId,
  PlayerScoreBreakdown,
  PlayerState,
} from "./player";
export type { Supply } from "./supply";
export type { TileDef, TileInstance, TileRotation } from "./tile";
export type { LandmarkTokenInstance, WildlifeTokenInstance } from "./token";
export type { Wildlife } from "./wildlife";
export { WILDLIFE, WILDLIFE_LETTER } from "./wildlife";
